const bannerRouteMapping = {
    "": {
        title: "DDO Audit",
        subtitle: "Real-time Player Concurrency Data and LFM Viewer",
        miniature: false,
        showButtons: true,
    },
    live: {
        title: "Live",
        subtitle: "Server Status and Quick Info",
        miniature: true,
        showButtons: false,
    },
    servers: {
        title: "Servers",
        subtitle: "Server Population, Demographics, and Trends",
        miniature: true,
        showButtons: false,
    },
    grouping: {
        title: "Grouping",
        subtitle: "Live LFM Viewer",
        miniature: true,
        showButtons: false,
    },
    who: {
        title: "Who",
        subtitle: "Live Character Viewer",
        miniature: true,
        showButtons: false,
    },
    trends: {
        title: "Trends",
        subtitle: "Long-term Population Trends",
        miniature: true,
        showButtons: false,
    },
    quests: {
        title: "Quest Activity",
        subtitle: "Completion Times and Popularity",
        miniature: true,
        showButtons: false,
    },
    about: {
        title: "About DDO Audit",
        subtitle: "Real-time Player Concurrency Data and LFM Viewer",
        miniature: false,
        showButtons: true,
    },
    verification: {
        title: "Verification",
        subtitle: "Verify Your Characters",
        miniature: true,
        showButtons: false,
    },
    registration: {
        title: "Registration",
        subtitle: "Register Your Characters",
        miniature: true,
        showButtons: false,
    },
    friends: {
        title: "Friends",
        subtitle: "Add Your Friends",
        miniature: true,
        showButtons: false,
    },
    ignores: {
        title: "Ignore List",
        subtitle: "Block characters",
        miniature: true,
        showButtons: false,
    },
    activity: {
        title: "Activity",
        subtitle: "Detailed Character Activity",
        miniature: true,
        showButtons: false,
    },
    notifications: {
        title: "LFM Notifications",
        subtitle: "Set Up and Manage Notifications",
        miniature: true,
        showButtons: false,
    },
    timers: {
        title: "Timers",
        subtitle: "View and Manage Timers",
        miniature: true,
        showButtons: false,
    },
    feedback: {
        title: "DDO Audit",
        subtitle: "Real-time Player Concurrency Data and LFM Viewer",
        miniature: false,
        showButtons: true,
        hideSuggestionButton: true,
    },
    guilds: {
        title: "Guilds",
        subtitle: "Guild Membership and Activity",
        miniature: true,
        showButtons: false,
    },
    "owned-content": {
        title: "Content",
        subtitle: "Set Owned Content for Eligibility Filtering",
        miniature: true,
        showButtons: false,
    },
    "user-settings": {
        title: "User Settings",
        subtitle: "Import and Export Your Settings",
        miniature: true,
        showButtons: false,
    },
}

export { bannerRouteMapping }
